import { $, $$ } from '@utils';
import Swiper from 'swiper';
import { Navigation, A11y, FreeMode } from 'swiper/modules';
import dataLayerPushSlider from '@utils/dataLayerPushSlider';

function init() {
  if (!$('[data-au-tabs]')) return;

  buildSlider();
  addEventListeners();
}

// Check if slides overflow swiper-wrapper
function checkOverflow(swiper, progress) {
  const thisTabsModule = swiper.el.closest('[data-au-tabs]'),
    overflowingClass = 'au-tabs--overflowing',
    paddingRight = 16,
    sliderWidth = thisTabsModule.querySelector('[data-au-tabs-slider]').clientWidth,
    sliderWrapperWidth = thisTabsModule.querySelector('[data-au-tabs-slider-wrapper]').scrollWidth;

  if (progress >= 1) {
    thisTabsModule.classList.remove(overflowingClass);
  } else if (sliderWrapperWidth > sliderWidth - paddingRight) {
    thisTabsModule.classList.add(overflowingClass);
  } else {
    thisTabsModule.classList.remove(overflowingClass);
  }
}

function buildSlider() {
  $$('[data-au-tabs-slider]').forEach((slider) => {
    new Swiper(slider, {
      modules: [Navigation, A11y, FreeMode],
      navigation: {
        prevEl: slider.closest('[data-au-tabs]').querySelector('[data-au-slider-prev]'),
        nextEl: slider.closest('[data-au-tabs]').querySelector('[data-au-slider-next]'),
      },
      scrollbar: {
        el: slider.closest('[data-au-tabs]').querySelector('[data-au-slider-scrollbar]'),
      },
      slidesPerView: 'auto',
      freeMode: true,
      a11y: {
        enabled: true,
        slideRole: null,
      },
      spaceBetween: 24,
      slidesPerGroupAuto: true,
      on: {
        progress: (swiper, progress) => {
          checkOverflow(swiper, progress);
        },
        touchEnd(swiper, event) {
          dataLayerPushSlider(swiper, event);
        },
      },
    });
  });
}

function addEventListeners() {
  $$('[data-au-tab]').forEach((tab) => {
    if (tab.closest('[data-au-tabs-scroll-to-anchors]')) {
      tab.addEventListener('click', scrollToAnchor);
    } else {
      tab.addEventListener('click', toggleTabVisibility);
    }
  });
}

function toggleTabActive(e) {
  const tab = e.target,
    tabSiblings = tab.closest('[data-au-tabs]').querySelectorAll('[data-au-tab]');

  //toggle active tab
  tabSiblings.forEach((tab) => {
    tab.classList.remove('au-active');
  });
  tab.classList.add('au-active');
}

function toggleTabVisibility(e) {
  const tab = e.target,
    tabContentId = tab.dataset.auTab,
    tabContent = $(`[data-au-tab-content="${tabContentId}"]`),
    tabSiblings = tab.closest('[data-au-tabs]').querySelectorAll('[data-au-tab]');

  //toggle active/visible content
  toggleTabActive(e);

  //toggle active/visible content
  tabSiblings.forEach((tab) => {
    const tabContentSiblingsId = tab.dataset.auTab,
      tabContentSiblings = $(`[data-au-tab-content="${tabContentSiblingsId}"]`);

    if (tabContentSiblings) {
      tabContentSiblings.classList.remove('au-active');
      tabContentSiblings.classList.add('au-hide');
    }
  });
  if (tabContent) {
    tabContent.classList.add('au-active');
    tabContent.classList.remove('au-hide');
  }
}

function scrollToAnchor(e) {
  const tab = e.target,
    tabContainer = tab.closest('[data-au-tabs-scroll-to-anchors]'),
    tabContainerHeight = tabContainer.offsetHeight,
    tabContentId = tab.dataset.auTab,
    tabContent = $(`[data-au-tab-content="${tabContentId}"]`),
    spaceToTop = 24,
    header = $('.n-main-header-responsive'),
    headerHeight = header ? header.offsetHeight + tabContainerHeight + spaceToTop : tabContainerHeight + spaceToTop;

  //toggle active/visible content
  toggleTabActive(e);

  if (tabContent) {
    e.preventDefault();
    const targetPosition = tabContent.getBoundingClientRect().top + window.scrollY - headerHeight; // Adjust for fixed header

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth',
    });
  }
}

export default { init };
